<template>
    <div>
        <div class="background-slider">
            <img :src="images[Math.abs(currentNumber) % images.length]" alt="" class='main_body_img'>
        </div>
    </div>
</template>


<script>


export default {
    data(){
        return {
            images: [
                'imgs/maingallery/g1w.jpg',
                'imgs/maingallery/g6w.jpg',
                'imgs/maingallery/g7w.jpg',
                'imgs/maingallery/g14w.jpg',
                // 'imgs/maingallery/g16w.jpg',
                // 'imgs/maingallery/g17w.jpg',
                // 'imgs/maingallery/g15.jpg',

            ],
            currentNumber: 0,
            timer: null
        }
    },
    methods: {
        startRotation: function() {
            this.timer = setInterval(this.next, 8000);
        },

        stopRotation: function() {
            clearTimeout(this.timer);
            this.timer = null;
        },

        next: function() {
            this.currentNumber += 1
        }
    },
    computed: {
        currentImage: function() {
            return this.images[Math.abs(this.currentNumber) % this.images.length];
        }
    },
    mounted() {
        this.startRotation();
    }
}
</script>

<style lang="scss">

    .background-slider {
        opacity: 1;
        z-index: 0;
        position: fixed; 
        top: 0%; 
        left: -50%; 
        width: 200%; 
        height: 100%;
        margin-top: 56px;
        overflow:hidden;
        img {
            position: absolute; 
            top: 0; 
            left: 0; 
            right: 0; 
            bottom: 0; 
            margin: auto; 
            min-width: 50%;
            min-height: 50%;
            -webkit-filter: grayscale(50%); /* Safari 6.0 - 9.0 */
            filter: grayscale(50%);
        }
    }

</style>

